import React from "react";
import "../ShareHolderInfo.scss";
import ddp2024 from "../../../files/shareholder-info/DDP2024.pdf";
import ddp2023 from "../../../files/shareholder-info/DDP2023.pdf";
import ddp2022 from "../../../files/shareholder-info/DDP-2022.JPG";

const DividendDistribution = () => {
  return (
    <>
      <div className="shareholder_info">
        <div className="container">
          <div className="heading_box">Dividend Distribution Policy</div>
          <div className="dividend_report_link">
            <ul>
              <li>
                <a href={ddp2024} target="_blank" rel="noreferrer">
                  Dividend Distribution Policy 2024
                </a>
              </li>
              <li>
                <a href={ddp2023} target="_blank" rel="noreferrer">
                  Dividend Distribution Policy 2023
                </a>
              </li>
              <li>
                <a href={ddp2022} target="_blank" rel="noreferrer">
                  Dividend Distribution Policy 2022
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default DividendDistribution;
